import { filter } from "./tpl";

export class FilterTool {
    /**  验证是否为null
     * @param obj
     */
    public isNull(obj) {
        if (obj === '' || obj === null || obj === undefined || obj === 'undefined' || obj === 'null') {
            return true
        }
        return false
    }

    public isNullDefault(obj, defaultValue) {
        if (this.isNull(obj)) {
            return defaultValue;
        }

        return defaultValue;
    }

    /**
     * 克隆json
     * @param obj 
     * @returns 
     */
    jsonClone(obj) {
        return JSON.parse(JSON.stringify(obj))
    }

    /**
     * 展开数据
     * @param data 
     * @returns 
     */
    openData(data) {
        let newData = Object.assign({}, data);
        delete newData.__super;
        if (this.isNull(data.__super)) {
            return newData;
        } else {
            newData = Object.assign(this.openData(data.__super), newData);
        }

        return newData;
    }

    /**
     * 自动解析数据
     * @param value      
     * @returns 
     */
    autoFilterValue(value, data) {
        if (typeof (value) == 'string') {
            const result = filter(value, data);
            return result;
        }

        return value;
    }

    /**
     * 自动解析对象
     * @param object 
     * @param data 
     */
    autoFilterObject(object, orgObject, data) {

        if (this.isNull(object) || !Object.prototype.isPrototypeOf(object)) {
            return;
        }

        for (const key in orgObject) {
            var orgValue = orgObject[key];
            var value = object[key];

            // string
            if (typeof (orgValue) == 'string') {
                object[key] = filter(orgValue, data);
            }

            // array
            if (Array.prototype.isPrototypeOf(orgValue)) {
                for (let index = 0; index < orgValue.length; index++) {
                    const orgItem = orgValue[index];
                    const item = object[index];
                    this.autoFilterObject(item, orgItem, data);
                }
            }

            // object
            if (Object.prototype.isPrototypeOf(orgValue)) {
                this.autoFilterObject(value, orgValue, data);
            }
        }

    }

    /**
     * 布尔判断
     * @param content 
     * @param newData 
     * @param defaultValue 
     * @returns 
     */
    doFilterBoolean(content, newData, defaultValue: boolean = true) {
        if (this.isNull(content)) {
            return defaultValue;
        }

        return this.autoFilterValue(content, newData);
    }

}

export default new FilterTool();